import React from 'react';
import TextBox from 'devextreme-react/text-box';

export default function PlugCellTypeListField(data) {
    function formatData(data) {
        return data && (data.keyCode) + ' | ' + (data.seedsPerCell);
    }
    return (
        <div>
            <TextBox
                value={formatData(data)}
                readOnly={true} />
        </div>
    );
}
